import { ChangeDetectionStrategy, Component, HostBinding, computed, inject, input, signal } from '@angular/core';

import { TrackingSource } from '@frontend/sports/tracking/feature';

import { getMinListHeight } from '../../popular-bets-heights';
import { PopularBetsPodAddToBetslipComponent } from '../../popular-bets-pod-add-to-betslip/popular-bets-pod-add-to-betslip.component';
import { PopularBetsPodShowMoreComponent } from '../../popular-bets-pod-show-more/popular-bets-pod-show-more.component';
import { PopularBetsPodSummaryComponent } from '../../popular-bets-pod-summary/popular-bets-pod-summary.component';
import { PopularBetsExpandCollapseService } from '../../popular-bets-services/popular-bets-expand-collapse.service';
import { IPodHeightConfigModel, PodEventsModel } from '../../popular-bets.models';
import { PopularBetsBetBuilderPlusOptionsComponent } from '../popular-bets-bet-builder-plus-options/popular-bets-bet-builder-plus-options.component';
import { PopularBetsBetBuilderPlusPodHeaderComponent } from '../popular-bets-bet-builder-plus-pod-header/popular-bets-bet-builder-plus-pod-header.component';

@Component({
    selector: 'ms-popular-bets-bet-builder-plus-pod',
    standalone: true,
    templateUrl: './popular-bets-bet-builder-plus-pod.component.html',
    styleUrl: './popular-bets-bet-builder-plus-pod.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        PopularBetsBetBuilderPlusPodHeaderComponent,
        PopularBetsPodSummaryComponent,
        PopularBetsBetBuilderPlusOptionsComponent,
        PopularBetsPodShowMoreComponent,
        PopularBetsPodAddToBetslipComponent,
    ],
})
export class PopularBetsBetBuilderPlusPodComponent {
    @HostBinding('class') className = 'popular-bets-bet-builder-plus-pod';

    pod = input.required<PodEventsModel>();
    isEpcotEnabled = input.required<boolean>();
    visiblePodLegs = input.required<number>();

    private expand = signal(false);
    private popularBetsExpandCollapseService = inject(PopularBetsExpandCollapseService);

    minHeight = computed(() => {
        this.setVisibleOptionsLimit();
        return getMinListHeight(this.getMinPodHeightConfig());
    });

    onShowMoreLessButtonToggle(expand: boolean): void {
        this.expand.set(expand);
        this.pod().expand = expand;
        this.pod().visibleOptionsLimit = expand ? this.pod().preCreatedOptions!.length : this.pod().defaultNoOfLegs;
        this.popularBetsExpandCollapseService.setExpandCollapse(expand, this.pod().visibleOptionsLimit);
    }

    getTrackingDetails(): TrackingSource {
        // TODO: SGP+ tracking will be implemented here in future story planned
        return {
            ...this.pod().tracking,
            betDetails: '',
        };
    }

    private setVisibleOptionsLimit(): void {
        this.expand();

        if (this.visiblePodLegs()) {
            this.pod().visibleOptionsLimit = this.visiblePodLegs();
        }
    }

    private getMinPodHeightConfig(): IPodHeightConfigModel {
        return {
            rows: this.pod().visibleOptionsLimit,
            isEpcotEnabled: this.isEpcotEnabled(),
            showOptionPick: false,
            podType: this.pod().podType,
            isAllPodAreSameType: this.pod().isAllPodAreSameType,
        };
    }
}
